module.exports = __webpack_public_path__ + "img/lFwdA.b0172dc0.svg";